import { render, staticRenderFns } from "./TransferFrom.vue?vue&type=template&id=b32cf9b8&"
import script from "./TransferFrom.vue?vue&type=script&lang=js&"
export * from "./TransferFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports